"use client";

import { Star } from "lucide-react";
import type * as React from "react";
import { cn } from "../utils/mergeClassNames";
import { Text } from "./text";

interface StarRatingProps {
  rating?: number;
  number?: number;
}

export const StarRating: React.FunctionComponent<StarRatingProps> = (props) => {
  const { rating, number = 0 } = props;

  return (
    <div className="flex w-fit items-center">
      <div className="flex items-center">
        {[0, 1, 2, 3, 4].map((index) => (
          <Star
            key={index}
            className={cn(
              (rating ?? 0) > index ? "text-yellow-400 fill-yellow-400" : "text-gray-300",
              "h-5 w-5 flex-shrink-0",
            )}
            aria-hidden="true"
          />
        ))}
      </div>
      {number ? <Text className="ml-1">{number}</Text> : undefined}
    </div>
  );
};
